<template>
  <div class="search">
    <navBar />
    <banner2 :banner-h="h1" :banner-p="p1" :banner-img="img1" />
    <!-- 面包屑 -->
    <div class="Crumbs">
      <div>当前位置：首页><span>物流查询</span></div>
    </div>

    <div class="search-box">
      <!-- 搜索框 -->
      <div class="bill-number">
        <div class="order">
          <input
            v-model="orderNo"
            type="text"
            placeholder="您可以输运单号进行查询"
            class="order-no"
            @keyup.enter="searchOrder"
          />
          <button type="button" class="submit-button" @click="searchOrder">
            马上查单
          </button>
        </div>
        <div class="order-note" />
      </div>
    </div>

    <!-- 错误提示 -->
    <div v-if="errorMessage" class="error-message">
      {{ errorMessage }}
    </div>

    <!-- 加载状态 -->
    <div v-if="isLoading" class="loading">正在查询，请稍候...</div>

    <!-- 订单信息 -->
    <div class="order-info" v-if="orderData && orderData.order_info">
      <h3>订单信息</h3>
      <div class="info-card">
        <div class="info-item">
          <span class="label">收货人：</span>
          <span>{{ orderData.order_info.shr || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="label">收货电话：</span>
          <span>{{ orderData.order_info.shdh || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="label">收货地址：</span>
          <span>{{ orderData.order_info.shdz || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="label">件数：</span>
          <span>{{ orderData.order_info.jsjs || '-' }}</span>
        </div>
      </div>
    </div>

    <!-- 物流轨迹 -->
    <div class="block" v-if="orderData && orderData.tracking_info && orderData.tracking_info.length">
      <h3>物流轨迹</h3>
      <el-timeline>
        <el-timeline-item 
          v-for="(tracking, index) in sortedTrackingInfo"
          :key="index"
          :timestamp="formatTime(tracking.event_time)" 
          placement="top">
          <el-card>
            <h4>{{ eventTypes[tracking.event_type] || tracking.event_type }}</h4>
            <p>{{ tracking.notes || '' }}</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>
    <div v-else-if="!isLoading && (!orderData || (!orderData.order_info && !orderData.tracking_info)) && !errorMessage">
      <div class="no-order">暂无物流信息</div>
    </div>
  </div>
</template>

<script>
import banner2 from "../components/banner.vue";
import { Message } from 'element-ui';

export default {
  name: "Search",
  components: { banner2 },
  data() {
    return {
      h1: "物流查询",
      p1: "物流链路全知晓",
      img1: require("../assets/img/bannerjituan.png"),
      orderNo: "",
      orderData: null,
      isLoading: false,
      errorMessage: "",
      eventTypes: {
        'departure': '出发',
        'arrival': '到达中转站',
		'in_hub': '中转站已接收',
        'transfer': '转运',
        'delivery': '交付客户',
        'receipt': '客户签收'
      }
    };
  },
  computed: {
    sortedTrackingInfo() {
      if (!this.orderData || !this.orderData.tracking_info) return [];
      return [...this.orderData.tracking_info].sort((a, b) => {
        return new Date(b.event_time) - new Date(a.event_time);
      });
    }
  },
  created() {
    this.orderNo = this.$route.query.tracking_number || this.$route.query.orderNo || "";
    if(this.orderNo){
      this.searchOrder();
    }
  },
  methods: {
    searchOrder() {
      if(!this.orderNo){
        this.errorMessage = '请输入运单号';
        Message.warning(this.errorMessage);
        return;
      }
      
      this.isLoading = true;
      this.orderData = null;
      this.errorMessage = "";
      
      this.reqApi.getOrderInfo({tracking_number: this.orderNo}, (res) => {
        this.isLoading = false;
        if(res.status === 200) {
          this.orderData = res.data;
          // 检查是否有有效数据
          if (!res.data.order_info && (!res.tracking_info || !res.data.tracking_info.length)) {
            this.errorMessage = '暂无物流信息';
          }
        }else {
          this.errorMessage = res.msg || '查询失败';
          Message.error(this.errorMessage);
        }
      }, (err) => {
        this.isLoading = false;
        this.errorMessage = err.msg || '查询物流轨迹失败';
        Message.error(this.errorMessage);
      });
    },
    formatTime(timeString) {
      if (!timeString) return '';
      const date = new Date(timeString);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });
    }
  },
};
</script>

<style scoped>
/* 原有样式保持不变 */
/* 面包屑 */
.Crumbs {
  margin-left: 50px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 17px;
}
.Crumbs div {
  line-height: 46px;
}
.Crumbs span {
  color: #000000;
}

.search-box {
  display: flex;
  justify-content: center;
}

.no-order{
  text-align: center;
  padding: 50px 0;
  font-size: 22px;
  color: #8e8686;
}

.bill-number {
  bottom: 1rem;
  left: 25%;
  background-color: #fff;
  z-index: 10;
  border-radius: 10px;
  padding: 0px 10px 10px 10px;
  width: 50%;
}
.bill-number .order {
  padding: 1rem 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bill-number .order-no {
  border: 1px solid #c9c5c5;
  font-size: 1rem;
  padding: 20px 0 20px 10px;
  border-radius: 10px 0px 0px 10px;
  width: 85%;
}

.bill-number .order-btn {
  padding: 0rem 0.5rem;
}

.bill-number .submit-button {
  width: 15%;
  border-radius: 0px 10px 10px 0px;
  padding: 20px 0px;
  background: red;
  color: #fff;
  border: 1px solid;
  text-align: center;
  font-size: 14px;
}

/* 订单信息样式 */
.order-info, .block {
  width: 80%;
  margin: 20px auto;
}

.order-info h3, .block h3 {
  font-size: 18px;
  margin-bottom: 15px;
  color: #333;
}

.info-card {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.info-item {
  margin-bottom: 10px;
  line-height: 24px;
}

.info-item .label {
  font-weight: bold;
  margin-right: 5px;
}

.el-card {
  margin-bottom: 15px;
}

/* 新增错误提示样式 */
.error-message {
  color: #e74c3c;
  text-align: center;
  padding: 10px;
  margin: 10px auto;
  background-color: #fadbd8;
  border-radius: 4px;
  width: 80%;
}

.loading {
  text-align: center;
  padding: 20px;
  font-size: 16px;
  color: #666;
}
</style>